import { ISort, ISortField, initialSortModel, memberSortModel } from '../state-helpers/sorts';
import { IAction, ActionType, ISetSortAction } from '../actions/index';


export function sortsModel(state: ISort[], action: ISetSortAction) {
    if (typeof state === 'undefined') {
        state = initialSortModel;
    }

    switch (action.type) {
        case ActionType.BROWSER_NAVIGATION:
        case ActionType.SET_SORT:
            return state.map(updateSort(action.sortId));
        case ActionType.SET_SORT_MODEL:
            return action.sortModel;
        default:
            return state;
    }
}


function updateSort(sortId: string): (sort: ISort) => ISort {
    if (!sortId) {
        sortId = 'relevance';
    }

    return function (sort: ISort) {
        sort.selected = sort.id === sortId;
        return sort;
    }
}